/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Customer_Summary_NoteInputs */



/**
* | output |
* | --- |
* | "Per-seat and per-user charges are billed once members are added." |
*
* @param {Partner_Add_Customer_Summary_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_customer_summary_note = /** @type {((inputs?: Partner_Add_Customer_Summary_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Customer_Summary_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kosten pro Platz und pro Nutzer werden berechnet, sobald Mitglieder hinzugefügt werden.")
	return /** @type {LocalizedString} */ ("Per-seat and per-user charges are billed once members are added.")
});